import React from 'react';
import { Link } from 'react-router-dom';
import isoSocLogo from '../assets/iso-soc-logo-1.webp';
import bgDesktop from '../assets/fgc-tms-saas-financial-software-hero-banner.webp';
import bgMobile from '../assets/fgc-tms-saas-financial-software-hero-banner-mobile.webp';
import heroScissors from '../assets/Hero-scissors.webp';

const BannerBackground = () => (
    <>
        <div className="absolute inset-0 hidden md:block z-0">
            <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, #0B1221 0%, #1a2542 100%)', zIndex: -2 }} />
            <div className="absolute inset-0" style={{
                backgroundImage: `linear-gradient(to right, #0B1221 0%, #0B1221 40%, transparent 100%), url(${bgDesktop})`,
                backgroundPosition: 'right center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                zIndex: -1
            }} />
        </div>
        <div className="absolute inset-0 md:hidden z-0" style={{
            backgroundImage: `linear-gradient(to right, #080D1A 0%, #080D1A 40%, transparent 100%), url(${bgMobile})`,
            backgroundPosition: 'center, center bottom',
            backgroundRepeat: 'no-repeat, no-repeat',
            backgroundSize: 'cover, cover',
            backgroundColor: '#080D1A'
        }} />
    </>
);

const Hero = () => {
    return (
        <section className="relative w-full min-h-[636px] md:min-h-screen bg-[#080D1A] overflow-hidden flex items-start md:items-center">
            <BannerBackground />

            <div className="site-shell relative z-10 pt-32 pb-6 md:pt-32 md:pb-20">
                <div className="flex flex-col md:flex-row items-start md:items-center">
                    <div className="w-full md:w-3/4 lg:w-2/3 text-left">
                        <h1 className="font-oswald text-white text-3xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-4xl leading-[1.35] md:!leading-[1.35] mb-16 md:mb-4 font-normal">
                            <strong className="font-bold">
                                FGC TMS - A FIXED INCOME TRADING AND
                                <span className="[@media(min-width:788px)_and_(max-width:1023px)]:hidden xl:hidden"> </span>
                                <br className="hidden [@media(min-width:788px)_and_(max-width:1023px)]:block xl:block" />
                                TRADE MANAGEMENT SYSTEM.
                            </strong>
                        </h1>

                        <div className="relative">
                            <ul className="font-inter text-gray-200 text-[16px] md:text-[16px] lg:text-[19px] xl:text-[22px] leading-relaxed mb-10 md:mb-24 list-disc pl-5 flex flex-col gap-2">
                                <li>Cloud-native SaaS Based Fixed Income System</li>
                                <li>Trading, Operations, Clearing, Risk &amp; Compliance Engine</li>
                                <li>Trusted by leading Broker Dealers</li>
                                <li>Cut your systems cost by 50%+</li>
                            </ul>

                            <div className="absolute top-[180px] left-[22px]
                                [@media(width:344px)]:top-[185px]
                                [@media(width:344px)_and_(height:882px)]:top-[165px]
                                [@media(min-width:442px)_and_(max-width:544px)]:top-[155px]
                                [@media(min-width:544px)_and_(max-width:768px)]:top-[130px] md:top-[130px] md:left-[22px]
                                [@media(min-width:926px)_and_(max-width:1024px)]:top-[130px] lg:top-[135px] lg:left-[24px]
                                [@media(width:1024px)]:top-[145px]
                                [@media(min-width:1024px)_and_(max-width:1174px)]:top-[145px]
                                [@media(min-width:1174px)_and_(max-width:1280px)]:top-[145px]
                                [@media(min-width:1280px)_and_(max-width:1329px)]:top-[165px]
                                [@media(min-width:1328px)]:top-[165px]">
                                <img
                                    src={heroScissors}
                                    alt="Cut Your Costs"
                                    className="w-auto h-auto max-w-[280px] md:max-w-[280px] lg:max-w-[400px] [@media(min-width:1024px)_and_(max-width:1279px)]:max-w-[350px]"
                                    fetchPriority="high"
                                />
                            </div>
                        </div>

                        <div className="relative flex flex-row items-center gap-2 mt-0 md:mt-8">
                            <Link
                                to="/schedule-demo"
                                className="bg-[#00C2FF] hover:scale-105 transition-transform duration-300 text-[#FFFFFF] text-[14px] sm:text-[16px] md:text-lg font-bold py-3.5 sm:py-3 md:py-4 px-7 sm:px-8 md:px-12 rounded-[16px] shadow-lg whitespace-nowrap md:-mt-12 inline-block text-center"
                            >
                                Request a Demo To See How!
                            </Link>
                        </div>

                        <div className="mt-24 md:hidden flex justify-start">
                            <img src={isoSocLogo} alt="ISO Certified" className="h-16 w-auto opacity-100 translate-x-[5px] -translate-y-[36px]" />
                        </div>

                        <div className="mt-16 hidden md:block w-full md:w-1/4 lg:w-1/3">
                            <div className="bottom-16 left-[10px]">
                                <img src={isoSocLogo} alt="ISO Certified" className="h-[60px] w-auto" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
